export default [
    {
      path: '/userCenter',
      name: 'userCenter',
      meta: {
          title: '个人数据中心'
      },
      component: () => import('@/views/userCenter')
    },
  ]